import React from 'react';

export function MetadataEditor({ items, onChange }) {
  const rows = items?.length ? items : [{ label: '', value: '' }];

  function updateRow(index, field, value) {
    const next = rows.map((r, i) => (i === index ? { ...r, [field]: value } : r));
    onChange(next);
  }

  function addRow() {
    onChange([...rows, { label: '', value: '' }]);
  }

  function removeRow(index) {
    if (rows.length <= 1) {
      onChange([{ label: '', value: '' }]);
      return;
    }
    onChange(rows.filter((_, i) => i !== index));
  }

  return (
    <div className="metadata-editor">
      <label className="form-label">Product metadata</label>
      <p className="text-secondary small">Shown to consumers when they verify this coupon.</p>
      {rows.map((row, index) => (
        <div key={index} className="row g-2 mb-2 align-items-center">
          <div className="col-md-4">
            <input
              className="form-control form-control-sm"
              placeholder="Label (e.g. Product)"
              value={row.label}
              onChange={(e) => updateRow(index, 'label', e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <input
              className="form-control form-control-sm"
              placeholder="Value"
              value={row.value}
              onChange={(e) => updateRow(index, 'value', e.target.value)}
            />
          </div>
          <div className="col-md-2">
            <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => removeRow(index)}>
              Remove
            </button>
          </div>
        </div>
      ))}
      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={addRow}>
        Add field
      </button>
    </div>
  );
}

export function cleanMetadata(items) {
  return (items || [])
    .map((r) => ({ label: String(r.label || '').trim(), value: String(r.value || '').trim() }))
    .filter((r) => r.label && r.value);
}
